var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sold-page"},[_c('lazy-image',{staticClass:"sold-page-photo",attrs:{"src":_vm.getPhotoByIndex(0).xl,"alt":"Real property"}}),_c('div',{staticClass:"sold-page-content"},[_c('div',{staticClass:"sold-page-address"},[_vm._v(_vm._s(_vm.getFullAddress))]),_c('div',{staticClass:"sold-page-label"},[_vm._v("Sold")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }